/**
 * 商品服务（v2.2）
 */
import { api } from './api'

export interface Product {
  _id: string
  brandId: string
  name: string
  description?: string
  images: string[]
  price: number // 分
  currency: string
  stock: number
  soldCount: number
  status: 'active' | 'inactive' | 'soldout'
  deliveryDays: number
  createdAt: string
}

export interface ProductListResult {
  items: Product[]
  total: number
  page: number
  limit: number
}

export const productService = {
  /** 商品列表（C 端公开；支持按品牌过滤） */
  getProducts: (params: { page?: number; limit?: number; brandId?: string } = {}) =>
    api.get<ProductListResult>('/products', params),

  getProduct: (id: string) => api.get<Product>(`/products/${id}`),
}
